const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88C5CC"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M100,396c-15.436,0-28-12.564-28-28V140c0-15.436,8.564-24,24-24h316c15.436,0,28,12.564,28,28v224 c0,15.436-12.564,28-28,28H100z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CC584C"
    },
    cx: 95.812,
    cy: 140,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD464"
    },
    cx: 119.812,
    cy: 140,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#198058"
    },
    cx: 143.812,
    cy: 140,
    r: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M403.812,144c0,2.2-1.8,4-4,4h-232c-2.2,0-4-1.8-4-4v-8c0-2.2,1.8-4,4-4h232c2.2,0,4,1.8,4,4V144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M424,372c0,4.4-3.6,8-8,8H96c-4.4,0-8-3.6-8-8V172c0-4.4,3.6-8,8-8h320c4.4,0,8,3.6,8,8V372z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#406A80"
    },
    d: "M160,356c0,4.4-3.6,8-8,8h-40c-4.4,0-8-3.6-8-8V188c0-4.4,3.6-8,8-8h40c4.4,0,8,3.6,8,8V356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#406A80"
    },
    d: "M400,180c4.4,0,8,3.6,8,8v40c0,4.408-3.6,8-8,8H184c-4.4,0-8-3.592-8-8v-40c0-4.4,3.6-8,8-8H400z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 248,
    style: {
      fill: "#B3B3B3"
    },
    width: 232,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 260,
    style: {
      fill: "#B3B3B3"
    },
    width: 232,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 272,
    style: {
      fill: "#B3B3B3"
    },
    width: 232,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 284,
    style: {
      fill: "#B3B3B3"
    },
    width: 52,
    height: 52
  })), /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 284,
    style: {
      fill: "#E16B5A"
    },
    width: 52,
    height: 52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 296,
    y: 284,
    style: {
      fill: "#B3B3B3"
    },
    width: 52,
    height: 52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 284,
    style: {
      fill: "#B3B3B3"
    },
    width: 52,
    height: 52
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageIcon);
export default __webpack_public_path__ + "static/media/page-icon.5776f50f0a2e36cd51dd28e7f7f5e661.svg";
export { ForwardRef as ReactComponent };